import { MitgliedschaftSubPathEnum, MitgliedschaftViewStatsEnum } from "../enum/MitgliedschaftViewStatsEnums";


export const getSubPathFromView = (view: MitgliedschaftViewStatsEnum): MitgliedschaftSubPathEnum => {
  switch (view) {
    case MitgliedschaftViewStatsEnum.HOME:
      return MitgliedschaftSubPathEnum.HOME;
    case MitgliedschaftViewStatsEnum.CREATE_STAMMBLATT:
      return MitgliedschaftSubPathEnum.CREATE_STAMMBLATT;
    case MitgliedschaftViewStatsEnum.KONTAKTDATEN:
      return MitgliedschaftSubPathEnum.KONTAKTDATEN;
    case MitgliedschaftViewStatsEnum.PERSONENBETREUER:
      return MitgliedschaftSubPathEnum.PERSONENBETREUER;
    case MitgliedschaftViewStatsEnum.RUHEND_WIEDERBETRIEB_MELDUNG:
      return MitgliedschaftSubPathEnum.RUHEND_WIEDERBETRIEB_MELDUNG;
    case MitgliedschaftViewStatsEnum.STAMMBLATT_SUCHE:
      return MitgliedschaftSubPathEnum.STAMMBLATT_SUCHE;
    default:
      return MitgliedschaftSubPathEnum.HOME;
  }
};
